import React, {useEffect} from 'react';
import {Collapse, List, Typography, Image, Card, Row, Col} from 'antd';
import {Helmet} from "react-helmet-async";
import {useTranslation} from "react-i18next";
import ChatPromoBanner from "./Fragments/ChatPromoBanner";
import trafficSignsData from '../traffic_signs_data.json';

const {Panel} = Collapse;
const {Title, Text} = Typography;

const TrafficSigns = ({analytics}) => {
    const {t, i18n} = useTranslation();
    const isRu = i18n.language === 'ru';

    useEffect(() => {
        if (analytics) analytics();
    }, [analytics]);

    return (
        <Row style={{padding: '20px'}}>
            <Helmet>
                <title>{t('header.traffic_signs')} - AvtoDas</title>
                <meta name="description" content={isRu ? "Дорожные знаки, с описаниями и картинками." : "Ճանապարհային նշաններ, բացատրություններով և նկարներով։"}/>
            </Helmet>
            <Col span={24}>
                <Title level={2} className="text-center">{t('header.traffic_signs')}</Title>
            </Col>
            <Col span={24}>
                <Collapse 
                    accordion 
                    ghost 
                    defaultActiveKey={['warning']}
                    expandIconPosition="right"
                    style={{ background: '#f8f9fa', borderRadius: '12px', padding: '8px' }}
                >
                    {trafficSignsData.map((category) => (
                        <Panel 
                            header={
                                <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
                                    <div style={{ 
                                        width: '40px', 
                                        height: '40px', 
                                        background: '#1890ff', 
                                        borderRadius: '8px', 
                                        marginRight: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        fontSize: '18px'
                                    }}>
                                        {category.id.charAt(0).toUpperCase()}
                                    </div>
                                    <Title level={4} style={{ margin: 0, color: '#262626' }}>
                                        {isRu && category.name_ru ? category.name_ru : category.name}
                                    </Title>
                                </div>
                            } 
                            key={category.id}
                            style={{ 
                                marginBottom: '12px', 
                                background: 'white', 
                                borderRadius: '12px',
                                border: '1px solid #f0f0f0',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                            }}
                        >
                            <div style={{ padding: '0 12px 12px 12px' }}>
                                <Text type="secondary" style={{ display: 'block', marginBottom: '24px', fontSize: '15px', fontStyle: 'italic' }}>
                                    {isRu && category.description_ru ? category.description_ru : category.description}
                                </Text>
                                <List
                                grid={{
                                    gutter: 16,
                                    xs: 1,
                                    sm: 2,
                                    md: 2,
                                    lg: 3,
                                    xl: 4,
                                    xxl: 4,
                                }}
                                dataSource={category.signs}
                                renderItem={(sign) => (
                                    <List.Item style={{ height: '100%' }}>
                                        <Card 
                                            hoverable 
                                            bodyStyle={{ 
                                                display: 'flex', 
                                                flexDirection: 'column', 
                                                height: '220px', 
                                                padding: '16px' 
                                            }}
                                            style={{ 
                                                height: '100%', 
                                                borderRadius: '12px', 
                                                overflow: 'hidden',
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                                border: '1px solid #f0f0f0'
                                            }}
                                            cover={
                                                <div style={{
                                                    height: '160px', 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    justifyContent: 'center', 
                                                    background: '#ffffff',
                                                    padding: '24px',
                                                    borderBottom: '1px solid #f5f5f5'
                                                }}>
                                                    <Image
                                                        alt={isRu && sign.name_ru ? sign.name_ru : (sign.name || "Ճանապարհային նշան")}
                                                        src={`/${sign.localPath}`}
                                                        preview={false}
                                                        style={{ 
                                                            maxHeight: '110px', 
                                                            maxWidth: '100%', 
                                                            objectFit: 'contain',
                                                            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                                                        }}
                                                        fallback="/logo.png"
                                                    />
                                                </div>
                                            }
                                        >
                                            <div style={{ flex: 1, overflow: 'hidden' }}>
                                                <Title level={5} style={{ 
                                                    marginBottom: '8px', 
                                                    fontSize: '15px',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    height: '42px',
                                                    lineHeight: '21px'
                                                }}>
                                                    {isRu && sign.name_ru ? sign.name_ru : (sign.name || (isRu ? "Дорожный знак" : "Ճանապարհային նշան"))}
                                                </Title>
                                                <div style={{ 
                                                    fontSize: '13px', 
                                                    color: '#8c8c8c',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    lineHeight: '1.4'
                                                }}>
                                                    {isRu && sign.description_ru ? sign.description_ru : sign.description}
                                                </div>
                                            </div>
                                        </Card>
                                    </List.Item>
                                )}
                            />
                            </div>
                        </Panel>
                    ))}
                </Collapse>
            </Col>
        </Row>
    );
};

export default TrafficSigns;
